import { isEnumValue } from "@redotech/util/enum";
import * as z from "zod";

export enum ReturnMethod {
  CUSTOMER_SHIPS = "customer_ships",
  CUSTOMER_IN_STORE = "customer_in_store",
  PACKAGE_PICKUP = "package_pickup",
}

/** An instruction set on a return document: packing instructions per return method, or manual or QR code label instructions. */
export const PackingInstructionMethodSchema = z.union([
  z.enum(ReturnMethod),
  z.literal("manual_label"),
  z.literal("form_label"),
]);

export type PackingInstructionMethod = z.infer<
  typeof PackingInstructionMethodSchema
>;

export function isPackingInstructionMethod(
  value: string,
): value is PackingInstructionMethod {
  return (
    isEnumValue(value, ReturnMethod) ||
    value === "manual_label" ||
    value === "form_label"
  );
}

/** Error code when an approved translation was made from instructions that have since changed. */
export const RETURN_INSTRUCTIONS_CHANGED = "RETURN_INSTRUCTIONS_CHANGED";
